module.exports = __webpack_public_path__ + "static/media/torggatan.6556d2b9.jpeg";